@if (isVisibleCookies()) {
<div class="cookie-modal">
  <div class="cookie-content">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 col-md-8">
          <p><b>Usamos cookies</b></p>
          <p>
            Al hacer clic en "Aceptar todo", acepta el almacenamiento de cookies en su dispositivo con
            fines funcionales, analíticos y publicitarios. <br>
            Ver nuestra <a href="#!">política de privacidad</a>
            <br><br>
          </p>
        </div>
        <div class="col-sm-12 col-md-4">
          <button id="moreOptions" class="btn btn-primary w-100 py-2 fnt-bnt-cookie cookie-option-1" type="button">
            Más opciones
          </button>
          <button class="btn btn-primary w-100 py-2 fnt-bnt-cookie cookie-option-2" type="button" (click)="setCookie()">
            Aceptar todo
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
}
